'use client';
import React from 'react';
import { FaCaretDown, FaCaretUp } from 'react-icons/fa6';
import { CircularChart } from '@benzinga/charts-ui';
import { ErrorBoundary } from '@benzinga/core-ui';
import { formatPrice } from '@benzinga/utils';

import styles from './rankings.module.scss';

export const RankingQuoteCard = ({ compact = false, position, hideTicker = false, ticker }) => {
  const chartSizeClass = compact ? 'min-h-10 min-w-10' : 'min-h-14 min-w-14';
  return (
    <ErrorBoundary name="RankingQuoteCard">
      <a
        className={`${styles['quote-card']}${compact ? ` ${styles['quote-card-compact']}` : ''}`}
        href={hideTicker ? `/screener` : `/quote/${ticker?.symbol}`}
        rel="noopener noreferrer"
        target="_blank"
      >
        <span className={styles['quote-card-position']}>{position}.</span>
        <div className="flex h-full min-w-0 flex-grow flex-col items-start justify-between">
          <div className={styles['quote-card-header']}>
            <div className="flex flex-row items-center">
              <div className={styles['quote-card-name'] + `${hideTicker ? ' blur-md' : ''}`}>
                <h4>{ticker?.symbol}</h4>
                {(ticker?.name || ticker?.companyName) && <div>{ticker?.name ?? ticker?.companyName}</div>}
                {ticker?.type === 'CRYPTO' && <div>{ticker?.description}</div>}
              </div>
            </div>
          </div>
          <div className={styles['quote-card-price']}>
            <div>${formatPrice(ticker?.lastTradePrice ?? ticker?.price)}</div>
            {ticker?.changePercent && (
              <span className={ticker?.changePercent > 0 ? 'text-green-500' : 'text-red-500'}>
                {ticker?.changePercent > 0 ? <FaCaretUp size={12} /> : <FaCaretDown size={12} />}
                {Number(ticker?.changePercent).toFixed(2)}%
              </span>
            )}
          </div>
        </div>
        {ticker?.rankingValue && (
          <div className={chartSizeClass}>
            <React.Suspense fallback={<div className={compact ? 'h-10 w-10' : 'h-14 w-14'}></div>}>
              <CircularChart
                backgroundColor={'rgba(48, 191, 96, 0.1)'}
                indicatorColor={'rgba(48, 191, 96, 0.1)'}
                showPercent={false}
                textColor={'#0F993D'}
                trackColor={'#30BF60'}
                value={Number(ticker?.rankingValue?.toFixed(2))}
              />
            </React.Suspense>
          </div>
        )}
      </a>
    </ErrorBoundary>
  );
};
